// extracted by mini-css-extract-plugin
export default {"float-shadow":"SmallCard_float-shadow__emHan"};